import { useSelector } from 'react-redux'
import RootState from 'store/state'

export default function useCall(): RootState['call'] {
    const call = useSelector<RootState, RootState['call']>(({ call }) => call)

    return call
}
